export default "__VITE_ASSET__de8cffa2__"